import { Link } from "react-router-dom";
import { Compass, Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FFF7E6] flex flex-col items-center justify-center text-center px-6" data-testid="not-found-screen">
      <div className="w-20 h-20 rounded-3xl bg-[#C4B5FD]/30 flex items-center justify-center mb-6"><Compass className="w-10 h-10 text-[#111827]/60" /></div>
      <h1 className="text-6xl font-black font-head text-[#111827]">404</h1>
      <p className="text-xl text-[#111827]/70 mt-2">This page took a wrong turn in the neighbourhood.</p>
      <Link to="/home" data-testid="notfound-return-home" className="mt-8 bg-[#F97316] text-white rounded-2xl py-4 px-8 font-bold flex items-center gap-2"><Home className="w-5 h-5" /> Return Home</Link>
    </div>
  );
}
